import { SidebarLayout } from '@/core/layouts/sidebar-layout';
import { createCustomerRoutes } from '@/core/router';

export function CustomerLayout() {
  const routes = createCustomerRoutes();

  return <SidebarLayout routes={routes} mainClassName="flex-1 overflow-y-auto contain-paint" />;
}
